import { createFileRoute } from '@tanstack/react-router'
import { DataProcessingPage } from '@/components/pages/data-processing-page'

export const Route = createFileRoute('/data-processing')({
  component: DataProcessingPage,
  head: () => ({ meta: [{ title: 'Data processing — mkdn.app' }] }),
})
